import { createSelector } from 'reselect'
import { getPageData, getPageParams } from 'selectors/page'
import {
  getIsAdmin,
  getUserID,
  isAuthenticated as getIsAuthenticated,
} from 'selectors/user/session'
export { getIsAdmin } from 'selectors/user/session'
export { getPageIsReady, getPageData, getPageParams, getPagePath } from 'selectors/page'
export const getSearch = createSelector(
  getPageParams,
  (pageParams): Record<string, any> => pageParams.search || ''
)
export const areFiltersAvailable = createSelector(
  [getPageData],
  (pageData): boolean => pageData.filtersAvailable || false
)
export const getIsUsersCollection = createSelector(
  [getPageParams, getUserID, getIsAuthenticated],
  (params, userId, isAuthenticated): boolean =>
    (isAuthenticated && Number(userId) === Number(params.ownerId || 0)) || false
)
// Private Collection, we do NOT return algolia results from SSR
export const getHasInitialLoad = createSelector(
  [getPageData],
  (pageData): boolean => pageData.algoliaResults || false
)
export const getHasValidPermissions = createSelector(
  [getIsUsersCollection, getIsAdmin],
  (isUsersCollection, isAdmin): boolean => isUsersCollection || isAdmin || false
)